var modules_5c7da1b7 = {"wrapper":"Memo_module_wrapper__6c45a6fb"};
import "../../../../assets/esm/components/SelectionCalculator/components/Memo/Memo~CCs3uVwK.css";

export { modules_5c7da1b7 as default };
//# sourceMappingURL=Memo.module.scss.js.map
